import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/distributor/services/coupons.service';

@Component({
  selector: 'app-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.scss']
})
export class CouponListComponent implements OnInit {

  public loginData: any;

  public coupons: any = [];
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsLoading: boolean = false;
  
  public displayType: string; // grid/list

  public pageFilterData: any;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('D_LOGIN');

    this.displayType = 'grid'; // Default display type

    //this.getCoupons(); // THIS IS CALLED FROM onPageFilterChange()
  }

  // Get coupons
  getCoupons() {
    if (this.pageFilterData) {
      this.coupons = [];
      this.couponsCount = 0;
      this.couponsLoading = true;
      
      this._couponsService.getCoupons(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.pageFilterData.manufacturer, this.pageFilterData.brand, this.pageFilterData.retailer, this.pageFilterData.store, this.pageFilterData.coupon_source, this.pageFilterData.coupon_status, this.couponsPage).subscribe(async getCouponsResponse => {
        this.couponsLoading = false;

        if (getCouponsResponse.status === true) { // Success
          this.coupons = getCouponsResponse.coupons;
          this.couponsCount = getCouponsResponse.total_count;
        } else {
          this._utilService.showToast(getCouponsResponse.message, '', 'error', {});
        }
      }, error => { // Error from getCoupons
        this.couponsLoading = false;
      });
    }
  }

  // Coupons page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCoupons();
  }

  // On page filter change
  async onPageFilterChange(event: any) {
    this.pageFilterData = event;

    this.couponsPage = 1;
    this.getCoupons();
  }

  // Change display type
  changeDisplayType(type: string) {
    this.displayType = type;
  }

}
